import React from "react";

export default function GuestbookEntry({ entry }) {
  return (
    <div
      style={{
        marginBottom: "5px",
        width: "98%",
        border: "3px outset rgba(19, 22, 75, 0.8)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        color: "rgb(19, 22, 75)",
        textAlign: "left",
        background: "rgba(19, 22, 75)",
        padding: "10px",
      }}
    >
      <div
        style={{
          width: "100%",
          background: "rgba(19, 22, 75)",
          color: "white",
        }}
      >
        <p style={{ textAlign: "left", overflowWrap: "anywhere" }}>
          {entry.text}
        </p>
      </div>

      <p style={{ fontWeight: "200", color: "white" }}>
        Signed, {entry.user} on {new Date(entry.timestamp).toLocaleString()}
      </p>
    </div>
  );
}
